
function readablePrice (priceCents) { 
  return '$' + (priceCents / 100).toFixed(2); 
}

function isDiscountedItem(item) { 
  return item.line_price != (item.original_price * item.quantity) 
}

function totalQuantityOfVariant(variantID, cartItems) {
  return cartItems
    .filter(item => (item.variant_id == variantID))
    .reduce((acc, item) => (item.quantity + acc), 0)
}

function discountedQauntityOfVariant(variantID, cartItems) {
  return cartItems
    .filter(item => (item.variant_id == variantID && isDiscountedItem(item)))
    .reduce((acc, item) => (item.quantity + acc), 0)
}

function getLineNum(variantID, items) {
  let result = null;
  for (let i = 0; i < items.length; i++) {
    if (items[i].variant_id == variantID && !isDiscountedItem(items[i])) {
      return i + 1
    } else if (items[i].variant_id == variantID) {
      result = i + 1
    }
  }
  return result;
}

function totalQuantityInCollection(items, collection) {
  return items.reduce((acc, item) => {  

    return acc + item.quantity * collection
      .filter(product => product.id == item.product_id)
      .length

  }, 0)
}

module.exports = {
  readablePrice,
  isDiscountedItem,
  totalQuantityOfVariant,
  discountedQauntityOfVariant,
  getLineNum,
  totalQuantityInCollection
}
